<template>
  <div>
    <Header title="Planos" />
    <Loading v-if="loading_data" />
    <HandleDisplayPlans
      v-else
      :plans="PlanList"
      :kept="EditList"
      @update:kept="updateKept"
    />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HandleDisplayPlans from "@/handles/paas/plan/HandleDisplayPlans.vue";
import Loading from "@/components/Loading.vue";

import { getPaasPlans, thereArePlansInQueue } from "@/api/paas/plans";

export default {
  name: "PaasHistorico",
  components: {
    Header,
    HandleDisplayPlans,
    Loading
  },
  created() {
    this.$store.commit("setCurrentComponent", {
      component: "Paas"
    });
  },
  data: () => ({
    loading_data: false,
    PlanList: [],
    EditList: []
  }),
  methods: {
    updatePlanList() {
      // get array of plans in database through db api
      this.loading_data = true;
      getPaasPlans()
        .then(_ => {
          this.PlanList = _;
        })
        .finally(() => {
          this.loading_data = false;
        });
    },
    verifyIfthereArePlansInQueue(firstRun = true) {
      thereArePlansInQueue()
        .then(_ => {
          if (_) {
            setTimeout(
              this.verifyIfthereArePlansInQueue,
              3000,
              false
            );
            return;
          }
          if (!firstRun) {
            this.updatePlanList();
            return;
          }
        })
        .catch(() => {
          console.log("erro ao verificar planos em fila");
        });
    },
    updateKept() {
      this.EditList = this.$store.getters.getEditSaveList;
    }
  },
  mounted() {
    //Update PlanList
    this.EditList = this.$store.getters.getEditSaveList;
    this.updatePlanList();
    this.verifyIfthereArePlansInQueue();
  }
};
</script>
